// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import moment from 'moment'
import router from './router'
import store from './store/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'
// import 'element-ui/lib/theme-chalk/index.css'
import './assets/themes/element-ui/index.css'
import './assets/themes/index.less'
import 'mint-ui/lib/style.css'

// import 'default-passive-events'
import _ from 'lodash'
import axios from 'axios'
import Qs from 'qs'
import Json5 from 'json5'
import myaxios from './myaxios'
import zhcn from './monment-zh-cn.js'
import multiplyMaths, { toNewFixed } from './reloadToFixed.js'
// import pinyin from 'pinyin'
import common from '@/common/index.js'
import '@/common/directives.js'
import surgeryInfoExtraParamUtil from '@/common/SurgeryInfoExtraParamUtil.js'
import vwt from 'vue-wechat-title'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import {
    FontAwesomeIcon
}
    from '@fortawesome/vue-fontawesome'
import 'echarts'
import './assets/iconfont/iconfont.css'
import VueTouch from 'vue-touch'
import vkbeautify from 'vkbeautify'
import { themeMixin, getThemePrimaryColor, getThemePalette } from '@/utils/theme.js'

Vue.use(common)
// 全局注册主题 Mixin，所有组件可使用 $themePrimary / $themePalette / $isHisBlue
Vue.mixin(themeMixin)
Vue.prototype.$getThemePrimaryColor = getThemePrimaryColor
Vue.prototype.$getThemePalette = getThemePalette
ElementUI.Select.computed.readonly = function() {
    const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
    return !(this.filterable || this.multiple || !isIE) && !this.visible
}
// 关闭dialog滚动条
ElementUI.Dialog.props.lockScroll.default = false
Vue.use(ElementUI) //  引用element-ui 并设置尺寸
Vue.config.productionTip = false
//  图标
library.add(fas, far, fab)
Vue.component(`font-awesome-icon`, FontAwesomeIcon)
Vue.prototype.vkbeautify = vkbeautify

// 重写 tofixed方法，解决 toFixed方法 let n=0.825; n.toFixed(2) =0.82的问题
// eslint-disable-next-line no-extend-native
Number.prototype.toNewFixed = toNewFixed
// eslint-disable-next-line no-extend-native
Vue.prototype.$multiplyMaths = multiplyMaths
//  挂载JavaScript 日期处理类库
moment.locale(`zh-cn`, zhcn)
Vue.prototype.$moment = moment

Vue.prototype.$surgeryInfoExtraParamUtil = surgeryInfoExtraParamUtil
Vue.prototype.axios = axios
Vue.prototype.qs = Qs
Vue.prototype.myaxios = myaxios
Vue.prototype.$EventBus = new Vue()
// 多语言
Vue.prototype.T = function T(resourceName) {
    let resourceValue = ``
    let languageId = 1 // 默认设置成1 中文,后面根据本地化调整
    let languages = store.state.languages
    if (!languages || (languages && languages.length == 0)) {
        store.dispatch(`ADD_LANGUAGES`).then(data => {
            let resource = _.filter(store.state.languages, { resource_name: resourceName, language_id: languageId })
            if (resource && resource.length > 0) {
                resourceValue = resource[0].resource_value
            }
        })
    } else {
        let resource = _.filter(store.state.languages, { resource_name: resourceName, language_id: languageId })
        if (resource && resource.length > 0) {
            resourceValue = resource[0].resource_value
        }
    }

    return resourceValue
}
// 统一处理axios请求

axios.defaults.headers.post[`Content-Type`] = `application/x-www-form-urlencoded`
Vue.use(vwt)
Vue.use(_)

Vue.use(VueTouch, { name: `v-touch` })

Vue.filter(`dataFormat`, function(val, pattern = `YYYY/MM/DD HH:mm:ss`) {
    return val && moment(val).format(pattern) || ``
})
Vue.filter(`selectFormat`, function(val, pattern) {
    if (!pattern || _.size(pattern) == 0) {
        return val
    } else {
        var regPos = /^\d+$/ // 非负整数
        let e = _.find(pattern, [`value`, regPos.test(val) ? parseInt(val) : val])
        if (e) {
            return e.label
        }
        return val
    }
})
Vue.filter(`multiselectFormat`, function(val, pattern) {
    if (!pattern || _.size(pattern) == 0) {
        return val
    } else {
        let _selected = _.isString(val) ? val.split(`,`) : val
        let e = []
        _.forEach(pattern, function(p) { if (_.includes(_selected, p.value)) { e.push(p.label) } })
        if (e) {
            return _.join(e)
        }
        return val
    }
})
Vue.filter(`multiselectAllowCreateFormat`, function(val, pattern) {
    if (!pattern || _.size(pattern) == 0) {
        return val
    } else {
        let _selected = _.isString(val) ? val.split(`,`) : val
        // _selected 0 1 2 3 4
        // pattern 0: {value: '0', label: '女'}1: {value: '1', label: '男'}
        let e = []
        _.forEach(_selected, function(p) {
            var f = pattern.find(s => s.value == p)
            if (f) {
                e.push(f.label)
            } else {
                e.push(p)
            }
        })
        if (e) {
            return _.join(e)
        }
        return val
    }
})
/*  界面元素权限控制  */
Vue.directive(`hasPermission`, {
    inserted: function(el, { value: pemission }, vnode) {
        let permissionList = []
        vnode.context.$route.matched.forEach(r => {
            if (r.meta && r.meta.permissions) {
                permissionList.push(...r.meta.permissions)
            }
        })
        if (pemission !== `default` && (permissionList == undefined || permissionList.length == 0 || !permissionList.includes(pemission))) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
})

// 防多次点击，重复提交
Vue.directive(`preventReClick`, {
    inserted(el, binding) {
        el.addEventListener(`click`, () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
})

axios.get(`../static/config.json`).then(res => {
    let config = Json5.parse(res)
    axios.defaults.baseURL = config[`BASE_URL`]
    store.dispatch(`ADD_SYS_CONFIG`).then(data => {
        config = Object.assign({}, config, data)
        axios.docservice_base_url = config.DOCSERVICE_BASE
        if (!config.appKey) config.appKey = `ACIS7.0`
        // ACIS-22241新疆和田地区人民医院-系统登录后的界面增加显示医院名称
        if (typeof (winformMsg) != `undefined` && config.ShowHospitalInTitle == 1) {
            // cef 下设置医院名称
            Vue.directive(`wechat-title`, function(el, binding) {
                document.title = config.HospitalName + `-` + binding.value || ``
            })
        }

        // eslint-disable-next-line no-unused-vars
        let v = new Vue({
            el: `#app`,
            data: config,
            // i18n,
            store,
            router,
            components: { App },
            template: `<App/>`
        })
    })
})



// WEBPACK FOOTER //
// ./src/main.js